.chip {
  display: inline-flex;
  align-items: center;
  min-width: 2.5rem;
  /* never wider than the space it is given; a very wide container still gets a sane cap */
  max-width: min(100%, 24rem);
  min-height: 1.5rem;
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  font-weight: 600;
}
